import { request } from './request';
export function getWebInfo() {
    return request({
        url: '/admin/webinfo',//管理员获取网站信息接口
    })
}
export function getUserInfo() {
    return request({
        url: '/admin/users',//管理员获取用户信息接口
    })
}
export function getSuggestion() {
    return request({
        url: '/admin/feedback',//管理员获取反馈意见接口
    })
}
export function getProjectDetail(proId) {
    return request({
        url: '/admin/projectDetail',//管理员获取项目详细信息接口
        params:{
            projectId:proId
        },
        method:'post'

    })
}

export function getUserProjects(id,offset,limit) {
    return request({
        url: 'project/limit',//管理员获取用户的项目接口
        params:{
            userId:id,
            offset:offset,
            limit:limit,
        }
    })
}
export function downloadReportApi(path) {
    return request({
      url: "/download/data", //下载数据文件接口
      params:{
          path:path,
      },
      responseType: 'blob'
    });
  }

export function adminLogout() {
    return request({
        url: '/admin/logout',//管理员登出接口
    })
}

